import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { BehaviorSubject, combineLatest, Observable, of } from 'rxjs';
import { filter, mergeMap } from 'rxjs/operators';

import { fromCarl } from 'src/app/store/common/common.selectors';
import { selectRouteState } from 'src/app/store/router/router.selectors';

import { Theme } from './theme.enum';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {
  private readonly themeSubject = new BehaviorSubject<Theme>(Theme.Light);

  public constructor(private readonly store: Store) {
    combineLatest([
      this.store.select(fromCarl.selectConfig<Theme>('theme.global')),
      // TODO: Fix with MBCC-2538
      // eslint-disable-next-line @ngrx/avoid-combining-selectors
      this.store.select(selectRouteState)
    ])
      .pipe(
        filter(([globalTheme]) => !!globalTheme),
        mergeMap(([globalTheme, routeState]) =>
          routeState?.appRoutePath
            ? this.store.select(fromCarl.selectConfig<Theme>(`theme.${routeState.appRoutePath}`, globalTheme))
            : of(globalTheme)
        )
      )
      .subscribe(theme => {
        this.themeSubject.next(theme);
      });
  }

  public get theme$(): Observable<Theme> {
    return this.themeSubject.asObservable();
  }

  public setTheme(theme: Theme): void {
    this.themeSubject.next(theme);
  }
}
